import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/components/common/message';
import { EditCouponModel } from '../../../models/inModels/Coupon';
import { ActivatedRoute, Router } from '@angular/router';
import { CouponService } from '../../../services/coupon/coupon.service';
import { SelectItem } from "primeng/components/common/selectitem";
import { BookService } from "../../../services/book.service";

@Component({
	selector: 'app-coupons-edit',
	templateUrl: './coupons-edit.component.html',
	styleUrls: ['./coupons-edit.component.css']
})
export class CouponsEditComponent implements OnInit {
	loading = false;
	msg: Message[];
	id;
	model: EditCouponModel;
	code: string;
	products: SelectItem[];
	selectedProduct: SelectItem;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private couponService: CouponService,
		private bookService: BookService,) { }

	ngOnInit() {
		this.loading = true;
		this.id = this.route.snapshot.params.Id;
		this.couponService.get(this.id).subscribe(
			coupon => {
				this.model = new EditCouponModel(coupon);
				this.code = coupon.CodeFormatted;
				console.log(coupon);
				this.selectedProduct = { value: coupon.BookId, label: coupon.Book };
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.msg = [];
				this.msg.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	save(): void {
		this.loading = true;
		console.log("🚀 ~ CouponsEditComponent ~ save ~ this.model:", this.model)
		this.couponService.edit(this.model)
			.subscribe(
				coupon => {
					this.model = new EditCouponModel(coupon);
					this.loading = false;
					this.msg = [];
					this.msg.push({ severity: 'success', summary: 'Coupon Edited', detail: 'Coupon Successfully Edited.' });
				},
				error => {
					this.loading = false;
					this.msg = [];
					this.msg.push({ severity: 'error', summary: 'Error', detail: error });
				});
	}

	goBack() {
		this.router.navigate(['/coupons']);
	}

	initDropDown(event) {
		this.bookService.getDropdown(event).then(
			x => {
				this.products = x;
			},
			error => {
				this.msg = [];
				this.msg.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setProduct(): void {
		this.model.BookId = this.selectedProduct.value;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/coupons/coupons-edit/coupons-edit.component.ts